export default __webpack_public_path__ + "static/media/timer_control_base.3c176743.svg";